import type { Module } from 'vuex';
import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import type { RootState } from '@/store/types';
import type { ITimelineState } from './types';

const namespaced: boolean = true;

export const timelineModule: Module<ITimelineState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
